import React from "react";
import {withTranslate} from "react-redux-multilingual"

const AppointmentCard = ({translate, currentReservation, resetBooking, cancelReservationSweetAlert, rescheduleReservation, language}) => {
    const breaks = currentReservation && currentReservation.clinic_break &&
    currentReservation.clinic_break.length ? (currentReservation.clinic_break).map((breakData, index) => {
        return (
            <div className="breaks-area" key={index}>
                <div className="break">
                    <i className="fas fa-arrow-left"></i>
                    <span className="title">{translate("from")}</span>
                    <p className="break-time">{breakData.time_from}</p>
                </div>
                <div className="break">
                    <i className="fas fa-arrow-right"></i>
                    <span className="title">{translate("to")}</span>
                    <p className="break-time">{breakData.time_to}</p>
                </div>
            </div>
        )
    }) : null;
    const upcoming_reservation_services = currentReservation.fees && currentReservation.fees.services
    && currentReservation.fees.services.length ? currentReservation.fees.services.map((res_service, index) => {
        return (
            <div className="subtotal-fees" key={index}>
                <p className="capitalized title">{res_service.name}</p>
                <p className="currency">{res_service.price + " " + translate('currency')}</p>
            </div>
        )
    }) : null;
    return (
        <div id="accordion">
            <div className="card shadow-4d relative">
                <div className="card-header">
                    <a className="card-link bolder"
                       id="toggle-collapse"
                       data-toggle="collapse" href={"#resDetails" + currentReservation.id}
                       aria-expanded="false"
                       aria-controls="resDetails">
                          <span
                              className="collapsed"><i className="fas fa-chevron-up"></i></span>
                        <span
                            className="expanded"><i className="fas fa-chevron-down"></i></span>
                    </a>
                    <div className="card-ok-header">
                        <div className="visit-main-info">
                            <div className="flex-container">
                                <div className="left">
                                    <p className="day">
                                        {currentReservation.day}
                                    </p>
                                    <p className="month">
                                        {currentReservation.month}
                                    </p>
                                </div>
                                <div className="right">
                                    <div className="res-details">
                                        <a href={"/doctor/" + currentReservation.doctor.unique_id}
                                           className="no-padding bolder"> <span
                                            className="branch-name clinic-name trimmed-p">{currentReservation.clinic_name} </span></a>
                                        <span className="branch-name res-options">
                                                <a href="/"
                                                   className="bolder dropdown-toggle pull-right font-22 margin-top-16 cursor-pointer btn-style-less"
                                                   data-toggle="dropdown"
                                                   role="button"
                                                   aria-expanded="false">
                                                <i className="fas fa-ellipsis-h  pull-right font-22 cursor-pointer"></i>
                                            </a>
                                               <ul className="dropdown-menu" role="menu">
                                                   <li className="cursor-pointer"
                                                       onClick={rescheduleReservation}>{translate("edit")}</li>
                                                   <li className="cursor-pointer"
                                                       onClick={cancelReservationSweetAlert}>{translate("delete")}</li>
                                               </ul>
                                            {/* <i onClick={cancelReservationSweetAlert}
                                               className="far fa-trash-alt red pull-right font-22 margin-top-16 cursor-pointer"></i>*/}
                                        </span>
                                    </div>
                                    <span
                                        className="time">{currentReservation.time + " " + currentReservation.time_range}</span>

                                </div>
                            </div>
                        </div>
                        <hr style={{margin: "1rem 1.25rem"}}/>
                    </div>

                    <div className="branch-area">
                        <i className="fas fa-map-marker-alt"></i>
                        <p className="trimmed-p">{currentReservation.address}</p>
                    </div>
                </div>

                <div id={"resDetails" + currentReservation.id} className="collapse hide">

                    <div className="card-body">
                        <hr style={{marginTop: 0}}/>
                        <div className="fees-area">
                            <div className="subtotal-fees">
                                <p className="capitalized title">{translate("fees")}</p>
                                <p className="currency">{currentReservation.fees.subtotal_fees + " " + currentReservation.fees.currency}</p>
                            </div>
                        </div>
                        {currentReservation.offer !== 0 ?
                            <div className="fees-area">
                                {/*     <p className="title capitalized">{translate("offer")}</p>
                                <div className="offer-details">
                                    <p className="offer-name"
                                       style={language === "ar" ? {paddingLeft: "10px"} : {paddingRight: "10px"}}>{currentReservation.offer}</p>
                                    <p className="offer-value">{translate("currency")}</p>

                                     <p className="offer-value">{currentReservation.offer.price +
                                    " " + (currentReservation.offer.price_type === 0 ? translate("currency") : "% " + translate("discount"))}</p>

                                </div>*/}
                                <div className="total-fees">
                                    <p className="capitalized title">{translate("offer")}</p>
                                    <p className="currency">{currentReservation.offer + " " + translate("currency")}</p>
                                </div>
                            </div> : null
                        }
                        <div className="fees-area">

                            {/*{upcoming_reservation_services}*/}

                            {upcoming_reservation_services ? <div>
                                {upcoming_reservation_services} </div> : null}
                            {currentReservation.fees && currentReservation.fees.promo !== 0 ?
                                <div className="subtotal-fees">
                                    <p className="capitalized title">{translate('promo_code')}</p>
                                    <p className="promo-currency">{"-" + " " + currentReservation.fees.promo + " " + translate('currency')}</p>
                                </div> : null}
                            {currentReservation.payment_method !== 0 ?
                                <div className="subtotal-fees">
                                    <p className="capitalized title">{translate('transaction_id')}</p>
                                    <p className="currency">{currentReservation.fees.transaction_id}</p>
                                </div> : null}
                            <hr style={{marginTop: 0}}/>
                            <div className="total-fees">
                                <p className="capitalized title">{translate("total_fees")}</p>
                                <p className="currency">{currentReservation.fees.total_fees + " " + currentReservation.fees.currency}</p>
                            </div>
                        </div>

                        {breaks ? <div>
                            <hr style={{marginTop: 0}}/>
                            <div className="breaks-title">
                                <i className="far fa-clock"></i>
                                <p className="title capitalized">{translate("break_times")}</p>
                            </div>
                            {breaks}
                        </div> : null}
                        {
                            currentReservation.account_type === 1 && currentReservation.doctor.hospital ?
                                <div className="hospital-profile">
                                    <hr/>
                                    <div className="hospital-profile-area">
                                        <a className="no-padding"
                                           href={"/doctor/" + currentReservation.doctor.hospital.unique_id + "/1"}>
                                            <img alt="profile" src={currentReservation.doctor.hospital.image}/>
                                        </a>
                                        <a className="no-padding"
                                           href={"/doctor/" + currentReservation.doctor.hospital.unique_id + "/1"}>
                                            <p>{currentReservation.doctor.hospital.name}</p>
                                        </a>
                                    </div>
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}
export default withTranslate(AppointmentCard);